import { NgModule } from '@angular/core';
import { Routes } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NotificationsComponent } from './notifications.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { AppSharedModule } from 'app/shared.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgrxAutoEntityModule } from '@briebug/ngrx-auto-entity';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { DEFAULT_DATE_FORMATS } from '../utils/default-date-formats';
import {MatBadgeModule} from '@angular/material/badge';
import { MatTabsModule } from '@angular/material/tabs';
import { STATUTNOTIFICATION, statutNotificationReducer } from './statut-notification/statut-notification.state';
import { StatutNotificationEffects } from './statut-notification/statut-notification.effects';
import { StatutNotification } from './statut-notification/statut-notification.model';
import { StatutNotificationService } from './statut-notification/statut-notification.service';
import { StatutNotificationFacade } from './statut-notification/statut-notification.facade';
import { USER, userReducer } from 'app/main/user/user.state';
import { UserEffects } from 'app/main/user/user.effects';
import { User } from 'app/main/user/user.model';
import { UserService } from 'app/main/user/user.service';
import { UserFacade } from 'app/main/user/user.facade';
import { MatChipsModule } from '@angular/material/chips';
import { TODO, todoReducer } from 'app/main/calendar-todo/todo.state';
import { TodoEffects } from 'app/main/calendar-todo/todo.effects';
import { Todo } from 'app/main/calendar-todo/todo.model';
import { TodoService } from 'app/main/calendar-todo/todo.service';
import { TodoFacade } from 'app/main/calendar-todo/todo.facade';



const routes: Routes = [
    // {
    //     path: '',
    //     component: NotificationListComponent,
    // },
    // {
    //     path: ':id',
    //     component: NotificationFormComponent,
    // }
];

@NgModule({
    declarations: [
         NotificationsComponent
    ],
    imports: [
        // RouterModule.forChild(routes),
        OverlayModule,
        PortalModule,
        MatTooltipModule,
        FuseSharedModule,
        AppSharedModule,
        MatBadgeModule,
        MatTabsModule,
        MatChipsModule,

        StoreModule.forFeature(USER, userReducer),
        StoreModule.forFeature(STATUTNOTIFICATION, statutNotificationReducer),

        StoreModule.forFeature(TODO, todoReducer),


        EffectsModule.forFeature([UserEffects,StatutNotificationEffects,TodoEffects]),
        NgrxAutoEntityModule.forFeature()

    ],
    providers: [
        { provide: StatutNotification, useClass: StatutNotificationService },
        StatutNotificationService,
        StatutNotificationFacade,

        { provide: User, useClass: UserService },
        UserFacade,
        UserService,

        { provide: Todo, useClass: TodoService },
        TodoService,
        TodoFacade,

        { provide: MAT_DATE_FORMATS, useValue: DEFAULT_DATE_FORMATS }
    ],
    exports: [
        // RouterModule,
         NotificationsComponent
    ]
})
export class NotificationsModule {
}
